<ng-container *ngIf="this.areas?.length > 1">
	<div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 mt-1 p-1">
		<h5 class="text-blue">Select Area</h5>
		<div class="dropdown" style="width: 100%">
			<button
				style="width: 100%; text-align: left"
				class="btn btn-lg btn-primary dropdown-toggle box-s"
				type="button"
				id="dropdownMenuButton"
				data-bs-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
			>
				<div class="row">
					<div class="col inline-block text-truncate">
						{{ this.selectedArea?.name }}
					</div>
					<div class="col-1">
						<i
							class="fa fa-chevron-down float-right"
							style="font-size: 30px"
						></i>
					</div>
				</div>
			</button>
			<div
				style="width: 100%"
				class="dropdown-menu"
				aria-labelledby="dropdownMenuButton"
			>
				<a
					class="dropdown-item"
					(click)="orgService.setArea(area)"
					*ngFor="let area of this.areas; let i = index"
					[class.active-menu-item]="selectedArea === area"
					>{{ area.name }}</a
				>
			</div>
		</div>
	</div>
</ng-container>
